






































import Vue from 'vue';
import layout from '@/libs/layout/school/course-list';
import { Component } from 'vue-property-decorator';
import { getCoursePageByTeacherId } from '@/api/school';
import { PGetCoursePageByTeacherId, TCoursePage } from '@/types/views/school';
import { TLayout } from '@/types/utils';
@Component({})
export default class Course extends Vue {
  private layout: TLayout = layout;
  private coursePage: TCoursePage = {
    list: [],
    totalPage: 0,
    totalQty: 0,
    currentPage: 1,
    pageSize: 20
  };
  private activated() {
    this.getCoursePageByTeacherById({
      teacherId: this.$route.params.id,
      currentPage: 1,
      size: this.coursePage.pageSize
    });
  }
  private handleSizeChange(size: number) {
    this.getCoursePageByTeacherById({
      teacherId: this.$route.params.id,
      currentPage: 1,
      size
    });
  }
  private handleCurrentChange(size: number) {
    this.getCoursePageByTeacherById({
      teacherId: this.$route.params.id,
      currentPage: size,
      size: this.coursePage.pageSize
    });
  }
  /**
   * 获取指定老师课程列表
   * @param {PGetCoursePageByTeacherId} params 参数
   */
  private async getCoursePageByTeacherById(params: PGetCoursePageByTeacherId) {
    try {
      let res: any = await getCoursePageByTeacherId(params);
      this.coursePage = res;
    } catch (e) {
      this.$message.error(e);
    }
  }
  /**
   * 渲染老师索引
   * 全部页数索引
   * @param {number} index
   * @returns {number} 索引值
   */

  private renderIndex(index: number) {
    return (
      index +
        1 +
        (this.coursePage.currentPage - 1) * this.coursePage.pageSize || 0
    );
  }
  private goToCourseDetail(id: string) {
    this.$router.push({
      path: `/educational/course-detail/${id}`
    });
  }
  private search() {
    this.getCoursePageByTeacherById({
      teacherId: this.$route.params.id,
      currentPage: 1,
      size: this.coursePage.pageSize
    });
  }
}
